import React from "react";
import "./index.css";
import { siteContent } from "../content";

const AmenitiesInfra = () => {
  const { amenities, infrastructure, title, eyebrow, description, image } = siteContent.amenitiesInfra;

  return (
    <div className="section amenitiesInfra">
      <div className="container-lg flex flexCol flexCenter">
        <h5 className="textCenter">{eyebrow}</h5>
        <h2 className="textCenter titleSec">{title}</h2>
        <p className="textCenter pSec">{description}</p>

        <div className="amenitiesInfraGrid flex flexRow flexWrap">
          <div className="amenitiesInfraCol">
            <h3 className="amenitiesInfraHeading">Amenities</h3>
            <ul className="amenitiesInfraList">
              {amenities.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>


          </div>

          <div className="amenitiesInfraCol">
            <h3 className="amenitiesInfraHeading">Infraestructura</h3>
            <ul className="amenitiesInfraList">
              {infrastructure.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmenitiesInfra;
